import axios from "axios"
import router from "../../router/router"


const base_url = "https://prep2go-en-es-api.vercel.app/user/"

const state = {
    fullName: "",
    role: "",
    level: "",
    lesson: "",
}

const getters = {
    getUser(state) {
        return state
    }
}

const mutations = {
    setUser(state, data) {
        state.fullName = data.fullName
        state.role = data.role
        state.level = data.level
        state.lesson = data.lesson
    },
    setLesson(state, lesson) {
        state.lesson = lesson
    }
}

const actions = {
    createUser({ getters }, data) {
        axios.post(`${base_url}create`, { ...data, token: getters.getToken }).then(response => {
            if (response.data.success) {
                M.toast({ html: 'User created', classes: 'green' })
                router.push({ name: 'users', params: { role: data.role + "s" } })
            } else if (response.data.exist) {
                M.toast({ html: 'This email already exists', classes: 'amber' })
            } else {
                M.toast({ html: 'There is a error', classes: 'red' })
            }
        })
    },
    updateUser({ getters }, data) {
        axios.post(`${base_url}update`, { ...data, token: getters.getToken }).then(response => {
            if (response.data.success) {
                M.toast({ html: 'Student updated', classes: 'green' })
                router.push({ name: 'users', params: { role: 'students' } })
            } else if (response.data.exist) {
                M.toast({ html: 'This email already exists', classes: 'amber' })
            }
            else {
                M.toast({ html: 'There is a error', classes: 'red' })
            }
        })
    },
    deleteUser({ getters }, user) {
        return axios.post(`${base_url}delete`, { token: getters.getToken, user })
    },
    login({ commit, dispatch }, data) {
        axios.post(`${base_url}login`, data).then(response => {
            // if logged in
            if (response.data.token) {
                // set token to local storage
                localStorage.setItem("token", response.data.token)

                //set Token to vuex
                commit("setToken", response.data.token)

                // set auth to vuex
                commit("setAuth", true)

                // get user
                dispatch("getUser", response.data.token).then(response => {
                    // set user to vuex
                    commit("setUser", response.data)

                    // redirect to home
                    if (response.data.role === "student") router.push({ name: 'home' })
                    // redirect to users
                    else router.push({ name: 'users', params: { role: 'students' } })
                })

                dispatch("info").then(response => commit("setInfo", response.data));

                // send success message
                M.toast({ html: 'logged in', classes: 'green' })
            } else {
                // send error message
                M.toast({ html: 'Email or password is wrong', classes: 'red' })
            }
        })
    },
    logout({ getters, commit }) {
        axios.post(`${base_url}logout`, { token: getters.getToken }).then(response => {
            // remove token from local storage
            localStorage.removeItem("token")

            // remove token from vuex
            commit("setToken", "")

            // set auth
            commit("setAuth", false)

            // remove user from vuex
            commit("setUser", { fullName: "", role: "", level: "", lesson: "" })
        })
    },
    getUser({ }, user) {
        return axios.post(`${base_url}user`, { user })
    },
    getUsers({ getters }, role) {
        return axios.post(`${base_url}users`, { token: getters.getToken, role })
    },
    searchUser({ getters }, query) {
        return axios.post(`${base_url}search`, { token: getters.getToken, query })
    }
}


export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js